<div class="page-container">
  <app-screen-loader
    [visible]="processing"
    [message]="'COO_BULK_UPLOAD.PROCESSING' | translate"
  ></app-screen-loader>

  <div class="relative page-edge-cut">
    <div class="form-card">
      <h1 class="section-heading">{{ "COO_BULK_UPLOAD.TITLE" | translate }}</h1>

      <div class="info-card-wrap">
        <app-validation-message
          [type]="'info'"
          [content]="{
            message: 'COO_BULK_UPLOAD.PRE_INFO_MESSAGE' | translate
          }"
          [showbutton]="false"
        ></app-validation-message>
      </div>

      <div class="info-card-wrap">
        <app-validation-message
          [type]="'default'"
          [content]="{
            title: 'COO_BULK_UPLOAD.HOW_TO_FILL_TITLE' | translate,
            message: 'COO_BULK_UPLOAD.HOW_TO_FILL_DESC' | translate,
          }"
          [showbutton]="false"
          (onBtnClick)="downloadTemplateFile($event)"
          [buttonText]="'COO_BULK_UPLOAD.DOWNLOAD_TEMPLATE' | translate"
        ></app-validation-message>
      </div>

      <div class="upload-block">
        <div class="file-control">
          <app-file
            [title]="'COO_BULK_UPLOAD.UPLOAD_TITLE' | translate"
            [description]="'COO_BULK_UPLOAD.UPLOAD_DESC' | translate"
            [attachments]="file"
            (onUploadRemove)="onFileChange($event)"
            (removeFile)="remove()"
            [accept]="'.json,application/json,text/json'"
            [documentServiceType]="'template'"
          ></app-file>
        </div>
      </div>

      @if (validationErrors.length) {
      <div class="error-list">
        @for (err of validationErrors; track $index) {
        <p>{{ err }}</p>
        }
      </div>
      }

      @if (uploadResults.length) {
      <div class="result-summary">
        <h2>{{ "COO_BULK_UPLOAD.RESULT.TITLE" | translate }}</h2>
        <p class="text-dc-navy! text-base!">
          {{
            "COO_BULK_UPLOAD.RESULT.COUNTS"
              | translate: { success: successCount, failed: failureCount }
          }}
        </p>

        @for (result of uploadResults; track $index) {
        <div class="result-item" [class.fail]="result.status !== 'success'" [class.ok]="result.status === 'success'">
          <img
            class="result-status-icon"
            [src]="result.status === 'success' ? '/icons/svg/file-success.svg' : '/icons/svg/error.svg'"
            [alt]="result.status === 'success' ? 'success' : 'error'"
          />
          <strong>{{
            "COO_BULK_UPLOAD.RESULT.OBJECT_PREFIX"
              | translate: { index: result.index }
          }}</strong>
          <span class="result-message">{{ result.message }}</span>
          @if (result.srNumber) {
          <span
            >({{ "COO_BULK_UPLOAD.RESULT.SR_LABEL" | translate }}:
            {{ result.srNumber }})</span
          >
          }
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>
